module.exports = __webpack_public_path__ + "img/preview-7.392a0f15.webp";